if (!customElements.get('search-suggestions')) {
  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const highlightSearchValue = (root, searchValue) => {
    if (!root || !searchValue.trim()) return;

    const matcher = new RegExp(escapeRegExp(searchValue.trim()), 'gi');
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let currentNode;

    while ((currentNode = walker.nextNode())) {
      if (!currentNode.parentElement.closest('b, strong, mark')) {
        textNodes.push(currentNode);
      }
    }

    textNodes.forEach((textNode) => {
      const text = textNode.nodeValue;
      if (!matcher.test(text)) {
        matcher.lastIndex = 0;
        return;
      }

      matcher.lastIndex = 0;
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      let match;

      while ((match = matcher.exec(text))) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        const strong = document.createElement('strong');
        strong.textContent = match[0];
        fragment.appendChild(strong);
        lastIndex = match.index + match[0].length;
      }

      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      textNode.replaceWith(fragment);
    });
  };

  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      const correctedTerms = terms;
      /*
      const correctedTerms = window.theme.getCorrectedSearchTerm
        ? window.theme.getCorrectedSearchTerm(terms)
        : terms;
      */

      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort('Existing request not needed');
      }
      this.searchSuggestionsAbortController = new AbortController();

      const suggestionParams = new URLSearchParams({
        q: correctedTerms,
        section_id: 'search-suggestions'
      });
      suggestionParams.set('resources[type]', 'query,collection,page,article');
      suggestionParams.set('resources[limit]', '10');

      fetch(`${theme.routes.predictiveSearch}?${suggestionParams.toString()}`, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';

          /* Custom typo correction is temporarily disabled.
          const correctionSuggestions = window.theme.getSearchCorrectionSuggestions
            ? window.theme.getSearchCorrectionSuggestions(terms)
            : [];

          if (correctionSuggestions.length) {
            const suggestions = document.createElement('div');
            suggestions.className = 'search-suggestions';

            const heading = document.createElement('span');
            heading.className = 'search-suggestions__heading';
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
            heading.textContent = 'Suggestions:';
            suggestions.appendChild(heading);

            const list = document.createElement('ul');
            list.className = 'search-suggestions__results-list';
            correctionSuggestions.forEach((suggestion) => {
              const item = document.createElement('li');
              item.className = 'search-suggestions__list-item';
              const link = document.createElement('a');
              link.className = 'search-suggestions__item';
              link.href = `${this.searchInput.closest('form').action}?q=${encodeURIComponent(suggestion)}`;
              link.textContent = suggestion;
              item.appendChild(link);
              list.appendChild(item);
            });
            suggestions.appendChild(list);
            this.appendChild(suggestions);
            highlightSearchValue(list, terms);
          */
          if (
            results &&
            results.firstElementChild &&
            results.firstElementChild.querySelector('.search-suggestions__item')
          ) {
            const suggestionBlock = results.firstElementChild;
            this.insertAdjacentElement('beforeend', suggestionBlock);
            highlightSearchValue(suggestionBlock.querySelector('.search-suggestions__results-list'), terms);
          } else if (this.closest('.section-header')) {
            const suggestions = document.createElement('div');
            suggestions.className = 'search-suggestions';

            const heading = document.createElement('span');
            heading.className = 'search-suggestions__heading';
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
            heading.textContent = 'Suggestions:';
            suggestions.appendChild(heading);

            const emptyMessage = document.createElement('div');
            emptyMessage.className = 'search-suggestions__empty';
            emptyMessage.textContent = 'No related suggestions';
            suggestions.appendChild(emptyMessage);

            this.appendChild(suggestions);
          }
        })
        .catch((error) => {
          console.warn(error); // eslint-disable-line no-console
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
